export default __webpack_public_path__ + "static/media/tr.df08d232.svg";